<div class="row">
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Trial/Non-Trial Year</mat-label>
      <mat-select panelClass="vendor-modal-select-panel" [required]="ValuesRequired()" [(ngModel)]="Year" #year="ngModel" name="year" (selectionChange)="onYearSelected($event.value)" [disabled]="VendorId() == null">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (year of Dropdowns.Years; track year) {
          <mat-option [value]="year">{{year}}</mat-option>
        }
      </mat-select>
      @if (year.errors?.required) {
        <mat-error>
          Year is required
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label matTooltip="Trial/Non-Trial Responsible Person">Trial/Non-Trial Investigator</mat-label>
      <mat-select panelClass="vendor-modal-select-panel" [required]="ValuesRequired()" [disabled]="Year == null || VendorId() == null" [(ngModel)]="FieldScientistId" #fieldScientist="ngModel" name="field-scientist" (selectionChange)="onFieldScientistSelected($event.value)">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (a of Dropdowns.FieldScientists; track a) {
          <mat-option [value]="a.Id">{{a.Name}}</mat-option>
        }
      </mat-select>
      @if (fieldScientist.errors?.required) {
        <mat-error>
          Investigator is required
        </mat-error>
      }
    </mat-form-field>
  </div>
  <div class="col-sm-4">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Vendor/Contact</mat-label>
      <mat-select panelClass="vendor-modal-select-panel" [required]="ValuesRequired()" [disabled]="FieldScientistId == null || VendorId() == null" [(ngModel)]="ContactId" #contact="ngModel" name="contact" (selectionChange)="onContactSelected($event.value)">
        @if (!ValuesRequired()) {
          <mat-option [value]="null"></mat-option>
        }
        @for (a of Dropdowns.Contacts; track a) {
          <mat-option [value]="a.Id">{{a.Name}}</mat-option>
        }
      </mat-select>
      @if (contact.errors?.required) {
        <mat-error>
          Contact is required
        </mat-error>
      }
    </mat-form-field>
  </div>
</div>
